var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CustomersTable.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b394d18a\"}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CustomersTable.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./libs/@db2b/keystone/components/Entities/Tables/CustomersTable.vue
// module id = 602
// module chunks = 1